module.exports = __webpack_public_path__ + "img/paypal.30d0a442.svg";